import { render } from "./NewOrderFlow.vue?vue&type=template&id=52f28c70&scoped=true"
import script from "./NewOrderFlow.vue?vue&type=script&lang=js"
export * from "./NewOrderFlow.vue?vue&type=script&lang=js"

import "./NewOrderFlow.vue?vue&type=style&index=0&id=52f28c70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f28c70"]])

export default __exports__